import { makeStyles } from '@material-ui/core';
import PatientQhsTable from './PatientQhsTable';
import { memo } from 'react';

const useStyles = makeStyles(theme => ({
  patientListContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 0,
  },
}));

const PatientListSection = ({
  metric,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.patientListContainer}>
      <PatientQhsTable
        metric={metric}
      />
    </div>
  );
};

export default memo(PatientListSection);
